import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";
import { useContext, useEffect, useState } from "react";
import SendInquiryModal from "./send-inquiry-modal/Send_Inquiry_Modal";
import Common_Btn_Yellow from "../common_component/common_btn_yellow/Common_Btn_Yellow";
import Success_Modal from "../contact-us/success_modal/Success_Modal";
import { Context } from "../../utils/context";

const Header = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const isActive = (path) => currentPath === path;

  const [holiday, setData] = useState([]);
  const [locations, setLocation] = useState([]);

  const { getData, IMG_URL } = useContext(Context);

  const getDataAll = async () => {
    const response = await getData("/master/cities/");

    setData(response?.data);
  };

  const getDataLocation = async () => {
    const response = await getData("/master/holiday/");

    setLocation(response?.data);
  };

  useEffect(() => {
    getDataAll();
    getDataLocation();
  }, []);

  return (
    <header className="header_wrapper">
      <div className="top_div"></div>

      <div className="header_container">
        <div className="container">
          <Navbar
            expand="lg"
            className="custom-navbar"
            onToggle={(value) => setExpanded(value)}
            expanded={expanded}
          >
            <div className="logo_section" onClick={() => navigate("/")}>
              <img
                src="/assets/images/header/header-logo.png"
                alt="Logo"
                className="logo_img"
              />
            </div>

            <div className="mobile_inquiry_btn">
              <Common_Btn_Yellow
                text="Send Inquiry"
                onClick={() => setOpenModal(true)}
              />
            </div>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="main-navbar-nav">
              <Nav className="mx-auto nav_links">
                <NavDropdown
                  id="holidays-dropdown"
                  title={
                    <span className="dropdown_title">
                      Holidays
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className="dropdown_icon"
                      />
                    </span>
                  }
                >
                  {locations?.map((item, index) => (
                    <NavDropdown.Item
                      onClick={() => setExpanded(false)}
                      as={NavLink}
                      to={`/home/holidays/city-break/${item.id}`}
                    >
                      {item.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                <NavDropdown
                  id="locations-dropdown"
                  title={
                    <span className="dropdown_title">
                      Locations
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className="dropdown_icon"
                      />
                    </span>
                  }
                >
                  {holiday?.map((item, index) => (
                    <NavDropdown.Item
                      onClick={() => setExpanded(false)}
                      as={NavLink}
                      to={`/location/${item?.id}`}
                    >
                      {item.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                <Nav.Link
                  onClick={() => setExpanded(false)}
                  as={NavLink}
                  to="/cruises"
                >
                  Cruise
                </Nav.Link>

                <Nav.Link
                  onClick={() => setExpanded(false)}
                  as={NavLink}
                  to="/about-us"
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  onClick={() => setExpanded(false)}
                  as={NavLink}
                  to="/contact-us"
                >
                  Contact Us
                </Nav.Link>

                <NavDropdown
                  id="usa-dropdown"
                  title={
                    <span className="dropdown_title">
                      India
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className="dropdown_icon"
                      />
                    </span>
                  }
                >
                  <NavDropdown.Item
                    onClick={() => setExpanded(false)}
                    as={NavLink}
                    to={`/location/7`}
                  >
                    USA
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>

              <div className="nav_right">
                <Common_Btn_Yellow
                  text="Send Inquiry"
                  onClick={() => setOpenModal(true)}
                />
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>

        <SendInquiryModal
          isOpen={openModal}
          onClose={() => {
            // setShowSuccessModal(true);
            setOpenModal(false);

            // setTimeout(() => {
            //   setShowSuccessModal(false);
            // }, 3000);
          }}
        />

        <Success_Modal
          show={showSuccessModal}
          handleClose={() => setShowSuccessModal(false)}
          successText="Form Submitted!"
        />
      </div>
    </header>
  );
};

export default Header;
